import { useEffect, useState, useContext } from 'react';
import $ from "jquery";
import {Card,ListGroup} from 'react-bootstrap';import {
    useNavigate
  } from "react-router-dom";
  import UserContext from '../../contexts/UserContext';

const Daycount = () => {

const navigate = useNavigate();
const [data,setData] = useState([]);
const {user,setUser} = useContext(UserContext);

const getUser = async (userId) => {
    await $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
         success : async function(response){
          if(response && response.user){
             await setUser(response.user);
          }else{
            setUser(null)
            navigate("/login")
          }
        },
        error: function(err){
            console.log("error")
            console.log(err)
        }
    })
}

function getData(){
    $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/attendanceCounts",
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
         success : function(response){
            if(response.message  && response.message.includes("Error in auth")){
                navigate("/login",{state: { message: response.message }})
              }
            setData(response);
        //   return  setDataArr(response);
          
        },
        error: function(err){
            console.log("error")
            console.log(err)
            navigate("/login")
        }
    })
}

useEffect(()=>{
  try{
    if(!user && localStorage.getItem('userSession')){
        getUser(JSON.parse(localStorage.getItem('userSession')))
      }else{
        if(!user){
          navigate("/login")
        }
      }
    }catch(e){
      if(!user){
        navigate("/login")
      }
    }
    getData();
},[])

const design = (
    <>
    {
        data.map((day)=>{
            const dateCurrent = day.date.split("/");
            const finalDate = new Date(Number(dateCurrent[2]),Number(dateCurrent[0]-1),Number(dateCurrent[1]));
            return <Card className="m-3">
            <Card.Header>{finalDate.toDateString()}</Card.Header>

            {/* <Card.Body> */}
                {/* <Card.Link onClick={()=>{editProfile(profile)}} href="#">Edit Profile</Card.Link> */}
                <ListGroup>
                <ListGroup.Item>Mumineen count : {day.personCount}</ListGroup.Item>
                <ListGroup.Item>Total Tiffins : {day.tiffinCount}</ListGroup.Item>
            </ListGroup>
            {/* </Card.Body> */}
            </Card>
        })
    }
    </> 
)
return design;
}

export default Daycount;